export const toDisplayPartnerId = (partnerId: number | string) =>
  `P${partnerId.toString().padStart(7, '0')}`;
